import { BASE_URL_API } from "constants/base-url-api";
import { getCookie } from "utils/functions-cookie";

type ApiResponse = {
  success: boolean;
  message: string;
  operation_id: string;
  detail?: string
};

type CardBinSuccessResponse = {
  response: Response;
  rest: { provider: string };
  detail?: never;
};

type CardBinErrorResponse = {
  response: Response;
  detail: string;
  rest?: never;
};

type CardBinResponse = CardBinSuccessResponse | CardBinErrorResponse;

export type RecurrentResponse = {
  customer: Customer
  recurrent_payment: RecurrentPayment
  detail?: string
}

type Customer = {
  name: string
}

type RecurrentPayment = {
  recurrent_payment_id: string
  next_recurrency: string
  start_date: string
  country: string
  currency: string
  amount: number
  current_recurrency_try: number
  order_number: string
  provider: string
  recurrency_day: number
  successful_recurrences: number
  recurrent_transactions: RecurrentTransaction[]
  status: number
  end_date: string
  interval: number
  links: Link[]
}

type RecurrentTransaction = {
  payment_id: string
  payment_number: number
  try_number: number
}

type Link = {
  method: string
  rel: string
  href: string
}


export const fetchSubscription = async (body: any) => {
  const authToken = getCookie("auth_token");

  if (!authToken) {
    throw new Error("Você não está autenticado.");
  }

  const response = await fetch(`${BASE_URL_API}/subscriptions/`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body)
  });

  const { detail, ...rest } = (await response.json()) as ApiResponse;

  if (response.status !== 201) {
    throw new Error(detail);
  }

  return rest;
};

export const fetchCardBin = async (bin_number: string): Promise<CardBinResponse> => {
  const authToken = getCookie("auth_token");

  if (!authToken) {
    throw new Error("Você não está autenticado.");
  }

  const response = await fetch(`${BASE_URL_API}/payments/card/bin/${bin_number}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    }
  });

  const responseData = await response.json();

  if (!response.ok) {
    return { response, detail: responseData.detail };
  }

  return { response, rest: responseData };
};

export const fetchRecurrent = async (recurrent_id: string) => {
  const authToken = getCookie("auth_token");

  if (!authToken) {
    throw new Error("Você não está autenticado.");
  }
  const response = await fetch(`${BASE_URL_API}/payments/${recurrent_id}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    }
  });

  const { detail, ...rest } = (await response.json()) as RecurrentResponse;

  if (response.status !== 200) {
    throw new Error(detail);
  }

  return rest;
}